import { Card } from "react-bootstrap";
import { BorderCard } from "./styles";

interface ExperienceCardProps {
  title: string;
  subtitle?: string;
  text?: string;
  period?: string;
}

const ExperienceCard: React.FC<ExperienceCardProps> = ({
  title,
  subtitle,
  text,
  period,
}) => {
  return (
    <BorderCard>
      <Card.Body>
        <div className="d-flex align-itens-center justify-content-between">
          <Card.Title>{title}</Card.Title>
        </div>
        <Card.Subtitle className="mb-2 text-muted">{subtitle}</Card.Subtitle>
        <Card.Subtitle className="d-lg-none  mb-3">{period}</Card.Subtitle>

        <Card.Text>{text}</Card.Text>
      </Card.Body>
    </BorderCard>
  );
};

export default ExperienceCard;
